import { ajaxPost } from '../../ajax'

const fetchTimeIntervals = async (params, store) => {
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: true })

  const response = await ajaxPost('/plugin/bookings/times', params)
  const json = await response.json()

  store.dispatch({ type: 'BOOKING_PLUGIN.SET_INTERVALS', payload: json.intervals })
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: false })
}

const fetchPrice = async (params, store) => {
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: true })

  const response = await ajaxPost('/plugin/bookings/price', params)
  const json = await response.json()

  store.dispatch({ type: 'BOOKING_PLUGIN.SET_PRICE', payload: json.price })
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: false })
}

const verifyPerson = async (params, store) => {
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: true })

  const response = await ajaxPost('/plugin/bookings/verify', params)
  const json = await response.json()
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: false })
  if (json.alert)
    store.dispatch({ type: 'BOOKING_PLUGIN.SET_ALERT', payload: json.alert })
  else
    store.dispatch({ type: 'BOOKING_PLUGIN.SET_PERSON', payload: json.person })
}

const confirmCode = async (params, store) => {
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: true })
  
  const response = await ajaxPost('/plugin/bookings/confirm', params)
  const json = await response.json()
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: false })
  if (json.alert)
    store.dispatch({ type: 'BOOKING_PLUGIN.SET_ALERT', payload: json.alert })
  else
    store.dispatch({ type: 'BOOKING_PLUGIN.SET_STEP', payload: 'payment' })
}

const resendCode = async (params, store) => {
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: true })
  
  const response = await ajaxPost('/plugin/bookings/resend', params)
  const json = await response.json()
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: false })
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_ALERT', payload: json.alert })
}

const bookField = async (params, store) => {
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: true })
  
  const response = await ajaxPost('/plugin/bookings', params)
  const json = await response.json()
  store.dispatch({ type: 'BOOKING_PLUGIN.SET_LOADING', payload: false })
  if (json.alert)
    store.dispatch({ type: 'BOOKING_PLUGIN.SET_ALERT', payload: json.alert })
  else
    store.dispatch({ type: 'BOOKING_PLUGIN.SET_STEP', payload: 'complete' })
}

const appendedParams = (params, state) => {
  return {...params, token: state.token, location_id: state.location.id}
}

const bookingParams = (state) => {
  const selectedFields = state.fieldSizes[state.selectedSize]
  const availableFields = selectedFields.filter(field => state.selectedInterval.fields.includes(field.id))
  const selectedField = availableFields[0]
  return { 
    field_id: selectedField.id,
    timestamp: state.selectedInterval.value,
    duration: state.selectedDuration,
    cost: state.price
  }
}

const BookingPlugin = store => next => action => {
  const state = store.getState().bookingPlugin
  const params = _.isEmpty(state) ? {} : appendedParams(action.payload, state)

  switch (action.type) {
    case 'BOOKING_PLUGIN.FETCH_INTERVALS':
      fetchTimeIntervals(params, store)
      break
    case 'BOOKING_PLUGIN.FETCH_PRICE':
      fetchPrice(params, store)
      break
    case 'BOOKING_PLUGIN.VERIFY_PERSON':
      verifyPerson(params, store)
      break
    case 'BOOKING_PLUGIN.CONFIRM_CODE':
      confirmCode(params, store)
      break
    case 'BOOKING_PLUGIN.RESEND_CODE':
      resendCode(params, store)
      break
    case 'BOOKING_PLUGIN.BOOK_FIELD':
      const fullParams = {...params, booking: bookingParams(state), person: state.person}
      bookField(fullParams, store)
      break
   }
   return next(action)
}

export default BookingPlugin
